import ComponentMap from './maps/ComponentMap/ComponentMap.jsx'
import DiffMap from './maps/DiffMap/DiffMap.jsx'
import DiffMarkdown from './maps/DiffMarkdown/DiffMarkdown.jsx'
import AnalyseMap from './maps/AnalyseMap/AnalyseMap.jsx'
import EmbeddedMap from './maps/EmbeddedMap/EmbeddedMap.jsx'
import HierarchyMap from './maps/HierarchyMap/HierarchyMap.jsx'
import MarkdownMap from './maps/MarkdownMap/MarkdownMap.jsx'
import MigrateMap from './maps/MigrateMap/MigrateMap.jsx'
import NavigatorMap from './maps/NavigatorMap/NavigatorMap.jsx'
import ProductMap from './maps/ProductMap/ProductMap.jsx'
import ShareMap from './maps/ShareMap/ShareMap.jsx'
import SnapshotMap from './maps/SnapshotMap/SnapshotMap.jsx'

export default function Map({
    analyse,
    componentId,
    componentType,
    contentType,
    mapData,
    mode,
    type,
    ...props
}) {
    if (analyse) {
        return <AnalyseMap {...analyse} {...props} />
    }
    else if ('diff' === mode) {
        if ('MD' === contentType) {
            return <DiffMarkdown type={type} {...props} />
        }
        else {
            return <DiffMap type={type} {...props} />
        }
    }
    else if ('hierarchy' === mode) {
        return <HierarchyMap type={type} {...props} />
    }
    else if ('migrate' === mode && mapData) {
        return <MigrateMap mapData={mapData} {...props} />
    }
    else if ('share' === mode) {
        return <ShareMap {...props} />
    }
    else if ('snapshot' === mode) {
        return <SnapshotMap {...props} />
    }
    else if (type) {
        if ('MD' === contentType) {
            return <MarkdownMap type={type} {...props} />
        }
        else if (componentId) {
            return (
                <ComponentMap
                    componentId={componentId}
                    componentType={componentType}
                    type={type}
                    {...props}
                />
            )
        }
        else {
            return <ProductMap type={type} {...props} />
        }
    }
    else if (mapData) {
        return <EmbeddedMap mapData={mapData} {...props} />
    }
    else {
        return <NavigatorMap {...props} />
    }
}
